import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CONSTANSTS } from '@core/constants';
import { Observable } from 'rxjs';
import { MeterIndices } from '../@shared/models/meter-indices.model';

@Injectable({
  providedIn: 'root'
})
export class MeterIndicesService {

  constructor(private http: HttpClient) { }

  GetFacilityMeterIndices(param: any): Observable<MeterIndices[]> {
    return this.http.get<MeterIndices[]>(CONSTANSTS.api.meterIndices.getFacilityMeterIndices, { params: param });
  }

  importExcelMeterIndices(param: any): Observable<any> {
    return this.http.post<any>(CONSTANSTS.api.meterIndices.importExcelMeterIndices, param);
  }

}
